// extracted by mini-css-extract-plugin
export default {"settings":"settingsTranslation_settings__JoTfG","customDropdown":"settingsTranslation_customDropdown__Sm7Ir"};